import RestClient from './rest-client'

export default class Csd extends RestClient {
  static get url () {
    return this.apiUrl + '/csds'
  }

  static get paramKey () {
    return 'csd'
  }

  static async findOne () {
    const { data } = await this._get(this.url)

    return new this(data)
  }

  static async import (formData) {
    const { data } = await this._post(this.url, formData)
    return data
  }
}
